module.exports = __webpack_public_path__ + "img/dashboardillustration.b09685e6.jpg";